import Typography from './Typography';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';

const TranslateTypography = ({ style, variant, children }) => {
  const { t } = useTranslation();
  const language = i18n.language;

  const text = () => {
    if (typeof children !== 'string') return children;
    if (language === 'ko' && !i18n.exists(children)) {
      return children;
    }
    else {
      return t(children);
    }
  };

  return (
    <Typography style={style} variant={variant}>
      {text()}
    </Typography>
  );
};

export default TranslateTypography;